import { apiV3Client } from './BaseRepository';

function fetchJobActivity({ from, size, jobId, eventTypes }) {
  return apiV3Client.post(`jobs/${jobId}/activity/_search`, { From: from, Size: size, EventNames: eventTypes });
}

export { fetchJobActivity };
